import { render } from "./404.vue?vue&type=template&id=a66bae7a&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=a66bae7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66bae7a"]])

export default __exports__